import { render, staticRenderFns } from "./TecSummary.vue?vue&type=template&id=952bc208&"
import script from "./TecSummary.vue?vue&type=script&lang=js&"
export * from "./TecSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports